import api from './index.js'

export default {

  // サインイン
  signIn(params) {
    return api.post('sign_in.json', params)
  },
}